import { StockResponse } from "../types/stock-statistics-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

export const getStocksupdate = async (number?: number): Promise<IResponse<StockResponse>> => {
  const response = await request<StockResponse>({
    method: "GET",
    url: `${API_PATHS.stockStatistics}`,
  });
  if (response.data.topGainers && response.data.topLosers) {
    response.data.topGainers = response.data.topGainers.slice(0, number);
    response.data.topLosers = response.data.topLosers.slice(0, number);
  }
  return response;
};
